import React from 'react';
import { Badge, BadgeProps } from '../Badge';
import { BpDesignSystem } from '../../types';
import { Avatar, AvatarProps, getAvatarSize } from './Avatar';
import { useBpDesignTheme } from '../../setup';

export type AvatarWithBadgeProps = BpDesignSystem.PropsWithChildren<
  Omit<AvatarProps, 'slotProps'> & {
    slotProps?: AvatarProps['slotProps'] & { badge?: BadgeProps };
    badgeColor?: string;
  }
>;

export const AvatarWithBadge = ({ slotProps, size, badgeColor, ...avatarProps }: AvatarWithBadgeProps) => {
  const { badge, ...avatarSlotProps } = slotProps ?? {};
  const theme = useBpDesignTheme();

  return (
    <Badge
      dataTest={`${avatarProps.dataTest ?? 'bp'}-badge`}
      overlap={!avatarProps.variant || avatarProps.variant === 'circular' ? 'circular' : 'rectangular'}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      badgeContent=" "
      variant="dot"
      slotProps={{
        badge: {
          style: {
            border: '1px solid #fff',
            backgroundColor: badgeColor ?? theme.tokens.colorSurfaceVariant,
            minWidth: 'auto',
            padding: 0,
            borderRadius: '50%',
            ...getAvatarSize(size, { scale: 0.25 })
          }
        }
      }}
      {...slotProps?.badge}
    >
      <Avatar size={size} key={avatarProps.src} slotProps={{ ...avatarSlotProps }} {...avatarProps} />
    </Badge>
  );
};
